<!--
 * @Author: jzh
 * @Date: 2020-03-17 17:31:32
 * @Description: file content
 * @LastEditTime: 2021-05-06 11:17:53
 * @LastEditors: DQL
 -->
<template>
  <el-dialog
    v-loading="loading"
    class="o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-70 o-dialog--xl-50"
    title="关联部门"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :inline="true"
        label-position="right"
        label-width="120px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="岗位代码"
              prop="roleCode"
            >
              <span
                class="c-form__read"
              >
                {{ fd.roleCode }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="岗位名称"
              prop="roleName"
            >
              <span
                class="c-form__read"
              >
                {{ fd.roleName }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="已选组织"
              prop="roleName"
            >
              <div class="o-el-tag-group">
                <el-tag
                  v-for="dept in fd.deptVOList"
                  :key="dept.deptCode"
                >
                  {{ dept.deptName }}
                </el-tag>
              </div>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="组织"
              prop="roleDescription"
            >
              <div
                v-loading.body="loading"
                class="dev-tree-container"
              >
                <el-tree
                  ref="tree"
                  class="o-tree-overflow--unset"
                  node-key="deptCode"
                  highlight-current
                  show-checkbox
                  check-strictly
                  lazy
                  :load="handleLoadDeptTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  @check="handleCheck"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        type="primary"
        @click="handleSave"
      >
        保存
      </el-button>
      <el-button
        @click="closeDialog()"
      >
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deptRoleService, deptTree } from '@/features/system/role/role.service.js';
export default {
  name: 'RoleDeptRelationshipDialog', // 关联部门
  props: {
    dlParams: {
      type: Object,
      default () {
        return {};
      },
      required: true
    }
  },
  data () {
    return {
      loading: false, // 页面loading状态

      dialogShow: true, // 模态框dialog显示

      /* 表单参数 Start */
      fd: {
        roleCode: '',
        roleName: '',
        deptVOList: []
      },
      /* 表单参数 End */

      /* 树组件配置 Start */
      // 树组件默认参数配置
      defaultProps: {
        label: 'deptName',
        children: 'children',
        isLeaf: (data, node) => {
          return !data.xjbz; // 下级标志
        }
      }
      /* 树组件配置 End */
    };
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * @description: 读取关联部门信息
     * @param {*}
     * @return {*}
     */
    getByRoleCode () {
      this.loading = true;
      deptRoleService.getByRoleCode(this.fd.roleCode)
        .then(rsp => {
          this.fd.deptVOList = rsp.data;
          this.setCheckedKeys(rsp.data);
        })
        .catch(err => {
          console.error('查询岗位关联对应的部门出错', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /* 部门树start */
    /**
     * @description: 处理加载部门树
     * @param {Object} node 包含数据的节点对象
     * @param {function} resolve 异步回调函数
     * @return {*}
     */
    handleLoadDeptTree (node, resolve) {
      this.loading = true;
      this.getDeptTree(node.data, resolve);
    },
    /**
     * @description: 读取部门树
     * @param {Object} _data 部门数据
     * @param {function} _resolve 异步回调函数
     * @return {*}
     */
    getDeptTree (_data, _resolve) {
      const params = {};
      if (_data) {
        params.deptCode = _data.deptCode;
      }
      deptTree(params)
        .then((rsp) => {
          _resolve(rsp.data);
        })
        .catch(err => {
          console.error('查询部门出错', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 把读取到的数据更新到树上
     * @param {Object} data
     * @return {*}
     */
    setCheckedKeys (data) {
      // 只需要设置key
      const newData = data.map((item) => { return item.deptCode; });
      console.log('nodeCodeList', newData);
      this.$refs.tree.setCheckedKeys(newData);
    },
    /**
     * @description: 处理勾选，需要依据勾选数据来判断是删除还是添加
     * @param {Object} data 部分数据（异步树时该数据不完整）
     * @param {Object} checkedData 勾选的数据
     * @return {*}
     */
    handleCheck (data, checkedData) {
      const { checkedKeys } = checkedData;
      // 判断当前传入的node对象是否在checkedKey中，如果存在代表勾选，应该添加到deptVOList，否则应该从数据中移除。
      const checked = checkedKeys.includes(data.deptCode);
      if (checked) { // 添加
        this.fd.deptVOList.push(data);
      } else { // 删除
        this.fd.deptVOList = this.fd.deptVOList.filter((item) => item.deptCode !== data.deptCode);
      }
    },
    /* 部门树 end */
    /**
     * @description: 更新岗位关联部门
     * @param {*}
     * @return {*}
     */
    handleSave () {
      this.loading = true;
      deptRoleService.saveByRoleCode(this.fd)
        .then(rsp => {
          this.$alert('岗位关联部门更新成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success'
          });
          this.$emit('closeDialog', '');
        })
        .catch(err => {
          console.error('更新岗位出错', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created () {
    // 1. 读取 roleCode 必须
    this.fd.roleCode = this.dlParams.roleCode;
    this.fd.roleName = this.dlParams.roleName;
    // 2. 判断 roleCode 不存在则抛出错误
    if (this.fd.roleCode === '') {
      this.$alert('请重新选择岗位后再操作！', '提示', {
        type: 'warning',
        callback: () => {
          this.closeDialog();
        }
      });
    } else {
      this.getByRoleCode();
    }
  }
};
</script>

<style lang="scss" scoped>
@import './role.scss';
</style>
